import React, { useEffect, useState } from "react";
import {
  TablePanel,
  RankBadge,
  Button,
  UserAvatar,
  CountryFlag,
} from "components/common";
import { callGetApiWithAuth } from "utils/api";
import { asDate, asVolume } from "utils/text";
import { varIs, varKey, varLabel } from "common/var";

export default function ListTable(props) {
  const [tableData, setTableData] = useState([]);
  const [paginationParam, setPaginationParam] = useState({
    currentPage: 1,
    perPage: 15,
    total: 0,
  });
  const [isLoading, setIsLoading] = useState(false);

  const onGetTableData = (res) => {
    setTableData(res.data.data);
    setPaginationParam({
      ...paginationParam,
      currentPage: res.data.current_page,
      total: res.data.total,
    });
    setIsLoading(false);
  };
  const onFailTableData = () => {
    setIsLoading(false);
  };
  const loadTableData = (paginationParam0) => {
    setIsLoading(true);
    const params = {
      ...props.searchParam,
      page: paginationParam0.currentPage,
      per_page: paginationParam0.perPage,
    };
    const q = Object.keys(params)
      .map((k) => k + "=" + params[k])
      .join("&");
    callGetApiWithAuth(
      `report/ticket_report/search?${q}`,
      onGetTableData,
      onFailTableData
    );
  };
  const onPageChange = (page) => {
    const paginationParam0 = {
      ...paginationParam,
      currentPage: page,
    };
    loadTableData(paginationParam0);
  };

  useEffect(() => {
    const paginationParam0 = {
      ...paginationParam,
      currentPage: 1,
    };
    loadTableData(paginationParam0);
  }, [props.searchParam]);

  return (
    <>
      <TablePanel
        title={`Searched Results`}
        data={tableData}
        loading={isLoading}
        paginationParam={paginationParam}
        onPageChange={onPageChange}
        columns={[
          {
            title: "ID",
            key: "uuid",
            render: (_, record) => <span>#{record.uuid}</span>,
          },
          {
            title: "Level",
            key: "level",
            render: (_, record) => <span>{record.level}</span>,
          },
          {
            title: "Username",
            key: "username",
            render: (_, record) => (
              <div className="d-flex align-items-center">
                <a
                  href="javascript:void(0)"
                  onClick={() => props.goUser(record)}
                >
                  {record.username}
                </a>
              </div>
            ),
          },
          {
            title: "Name",
            key: "name",
            render: (_, record) => (
              <div className="d-flex align-items-center">
                <UserAvatar
                  image={record.image}
                  title={`${record.first_name} ${record.last_name}`}
                  status={varKey("user.status", record.status)}
                  type={varKey("user.type", record.type)}
                  typeLabel={varLabel("user.type", record.type)}
                  joinDate={asDate(record.created_at)}
                />
              </div>
            ),
          },
          {
            title: "Country",
            key: "country",
            render: (_, record) => <CountryFlag country={record.country} />,
          },
          {
            title: "Enroller",
            key: "enroller",
            render: (_, record) => <span>{record.enroller.username}</span>,
          },
          {
            title: "Current Promoter Rank",
            key: "rank_id",
            render: (_, record) => (
              <span>
                {varIs("user.type", record.type, "affiliate") ? (
                  <RankBadge label={record.rank.name} />
                ) : (
                  ""
                )}
              </span>
            ),
          },
          {
            title: "Paid Promoter Rank",
            key: "pay_rank_id",
            render: (_, record) => (
              <span>
                {varIs("user.type", record.type, "affiliate") ? (
                  <RankBadge label={record.pay_rank.name} />
                ) : (
                  ""
                )}
              </span>
            ),
          },
          {
            title: "Currrent Builder Rank",
            key: "builder_rank_id",
            render: (_, record) => (
              <span>
                {varIs("user.type", record.type, "affiliate") ? (
                  <RankBadge label={record.builder_rank.name} />
                ) : (
                  ""
                )}
              </span>
            ),
          },
          {
            title: "Paid Builder Rank",
            key: "pay_builder_rank_id",
            render: (_, record) => (
              <span>
                {varIs("user.type", record.type, "affiliate") ? (
                  <RankBadge label={record.pay_builder_rank.name} />
                ) : (
                  ""
                )}
              </span>
            ),
          },
          {
            title: "Tickets",
            key: "ticket",
            render: (_, record) => (
              <div style={{ width: "250px" }}>{record.tickets}</div>
            ),
          },
        ]}
      />
    </>
  );
}
